import {SODeleteSesMessage} from '../../core/ses-message/so-delete-ses-message';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteSesMessage extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteSesMessage;
}